import React from 'react';
import { useSelector } from 'react-redux';

import { useFallbackVideo } from 'hooks/video';
import { VideoCtvRedux } from 'store-types';

import Carousel from './Carousel';

interface ContainerProps {
  hideCarousel?: boolean;
  onError?: ((error: unknown) => void) | null;
  [key: string]: unknown;
}

const Container = ({ hideCarousel = false, onError = () => {}, ...passThru }: ContainerProps) => {
  const [fallbackVideo] = useFallbackVideo();
  let heroData = useSelector((state: VideoCtvRedux) => state.kitchenSink.data?.hero?.data);
  const usePPlus = useSelector(
    (state: VideoCtvRedux) =>
      state.kitchenSink?.data?.config?.modules?.Auth?.params?.shortCode_PPlus,
  );
  const useMVPD = useSelector(
    (state: VideoCtvRedux) =>
      state.kitchenSink?.data?.config?.modules?.Auth?.params?.shortCode_MVPD,
  );

  if (usePPlus === '0' || useMVPD === '0') {
    heroData = heroData.filter(
      item =>
        !item.authTypes?.includes('paramountplus') &&
        !item.authTypes?.includes('adobe'),
    );
  }

  const carouselData =
    heroData && heroData.length > 0 ? heroData : [fallbackVideo];

  return <Carousel {...passThru} data={carouselData} hideCarousel={hideCarousel} onError={onError}  />;
};

export default Container;
